import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function PrivateRoute(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { component: Component, ...rest } = props;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = localStorage.getItem('token');
        const userDetail = localStorage.getItem('userDetail');
        
        // Check if token exists and is not null/undefined
        if (!token || token === 'null' || token === 'undefined') {
          navigate('/login', { state: { from: location }, replace: true });
          return;
        }

        // Try to parse token to ensure it's valid JSON
        const parsedToken = JSON.parse(token);
        if (!parsedToken) {
          localStorage.clear();
          navigate('/login', { state: { from: location }, replace: true });
          return;
        }

        // If all checks pass, user is authenticated
        setIsAuthenticated(true);
      } catch (error) {
        // If any error occurs (e.g., JSON parsing), clear storage and redirect
        console.error('Auth check error:', error);
        localStorage.clear();
        navigate('/login', { state: { from: location }, replace: true });
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, [navigate, location]);

  // Show nothing while checking authentication
  if (isChecking) {
    return null;
  }

  // Only render component if authenticated
  return isAuthenticated ? <Component {...rest} /> : null;
}

export default PrivateRoute;
